/* usage:
fast response for user interactions
await browserNextPaint();
expensive calculations
*/
export async function browserNextPaint() {
  return new Promise(resolve => requestAnimationFrame(() => setTimeout(resolve, 0)));
}

/* usage:
fast response for user interactions
runAfterNextPaint(() => {
  expensive calculations
});
*/
export function runAfterNextBrowserPaint(callback: () => void) {
  requestAnimationFrame(() => setTimeout(callback, 0));
}
